import React, { FC, ReactNode, DOMAttributes } from 'react';

import styled from '@emotion/styled';
import {
  compose,
  typography,
  space,
  color,
  variant,
  TypographyProps,
  FlexProps,
  flex,
  SpaceProps,
  ColorProps,
  layout,
  LayoutProps,
  ComponentsType
} from '@lucid/theme';

import decorate from '../decorate/decorate';

export type HeadingTagsType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export const headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

export interface HeadingProps
  extends ColorProps,
  LayoutProps,
  SpaceProps,
  TypographyProps,
  FlexProps,
  DOMAttributes<HTMLElement> {
  /** Sets the HTML id for the Heading. */
  id?: string;
  /** Sets the HTML tag for the Heading component. */
  as?: HeadingTagsType;
  /** The children passed to the Heading */
  children?: ReactNode;
  /** The available variants for the Heading component. */
  variant?: ComponentsType['Heading'] | ComponentsType['Typography'];
  /** Allows the component to get additional styles. */
  className?: string;
}

const headingStyleProps = compose(color, layout, space, typography, flex);

const StyledHeading: FC<HeadingProps> = styled.h1(
  variant({
    scale: 'headings',
    variants: {
      defaultVariant: {}
    }
  }),
  {
    label: 'heading'
  },
  headingStyleProps
);

const HeadingComponent: FC<HeadingProps> = ({ as, className, variant, ...rest }) => (
  <StyledHeading {...rest} as={as} className={className} variant={variant} />
);

// manually adding display name or it goes missing on build
HeadingComponent.displayName = 'Heading';
const Heading = decorate<HeadingProps>(HeadingComponent);
export { Heading };
export default Heading;
